export default function dropDownEvent() {
  $("#specialAdvisory>.tagsinput").off("click");
  $("#travelAlert>.tagsinput").off("click");
  $("#medical>.tagsinput").off("click");
  //set focus point
  $("#specialAdvisory>.tagsinput").on("click",function(){
    setTimeout(function(){
      $($("#specialAdvisory>.dropdown-menu").children()[0]).children()[0].focus();
      $($("#specialAdvisory>.dropdown-menu").children()[0]).children().val("");
      $($("#specialAdvisory>.dropdown-menu").children()[0]).children().trigger("input");
    },200);
  });
  $("#travelAlert>.tagsinput").on("click",function(){
    setTimeout(function() {
      $($("#travelAlert>.dropdown-menu").children()[0]).children()[0].focus();
      $($("#travelAlert>.dropdown-menu").children()[0]).children().val("");
      $($("#travelAlert>.dropdown-menu").children()[0]).children().trigger("input");
    },200);
  });
  $("#medical>.tagsinput").on("click",function(){
    setTimeout(function() {
      $($("#medical>.dropdown-menu").children()[0]).children()[0].focus();
      $($("#medical>.dropdown-menu").children()[0]).children().val("");
      $($("#medical>.dropdown-menu").children()[0]).children().trigger("input");
    },200);
  });

  //add country
  $(document).off("click",".countrysMenu > li > a");
  $(document).on("click",".countrysMenu > li > a",function(){
    let hasAllCountry = $(this).closest(".bootstrap-tagsinput").find(".countrysMenu > li > a").hasClass("allCountry");
    let isAll = $(this).data("allcountry");
    if(isAll === "all"){
      let el = $(this).closest(".bootstrap-tagsinput").find("span.tag");
      $.each(el,function(i){
        let countryOntagsinput = $.trim($(el[i]).text());
        let curCountrysMenu = $(this).closest(".bootstrap-tagsinput").find(".countrysMenu > li > a");
        curCountrysMenu.each(function(){
          if(countryOntagsinput == $(this).text()){
            $(this).parent().show();
          }
        });
      });
      $(this).closest(".bootstrap-tagsinput").find("span.tag").remove();
      $(this).addClass("allCountry");
      let newTag = $('<span class="tag label label-info">All<span data-role="remove" class="allCountries"></span> </span>');
      let $tagsinput = $(this).closest(".bootstrap-tagsinput").find(".tagsinput");
      newTag.insertBefore($tagsinput);
      return;
    }
    if(hasAllCountry){
      window.onresize();
      $("#hasSelectAll_modal").modal("show");
      return;
    }
    let curValue = $(this).text();
    let newTag = $('<span class="tag label label-info">'+ curValue + '<span data-role="remove"></span> </span>');
    let $tagsinput = $(this).closest(".bootstrap-tagsinput").find(".tagsinput");
    newTag.insertBefore($tagsinput);
    $(this).parent().hide();
  });
  //delete country
  $(document).off("click","[data-role='remove']");
  $(document).on("click","[data-role='remove']",function(){
    let hasAllCountries = $(this).hasClass("allCountries");
    let curText = $.trim($(this).parent().text());
    if(hasAllCountries){
      $(this).closest(".bootstrap-tagsinput").find(".countrysMenu .allCountry").removeClass("allCountry");
    }
    $(this).closest(".bootstrap-tagsinput").find(".countrysMenu li a:contains("+curText+")").parent().show();
    $(this).parent().remove();
  });
}


// WEBPACK FOOTER //
// ./src/component/dropDownEvent.js